<template>
  <div
      class="aida-render cus-radio-group"
      id="datacenter-cus"
      style="height: calc(100vh - 180px)"
  >
    <div class="flex p-10 hp100" style="padding-right: 0">
      <div class="flex1 hp100 overflow cs-left" style="overflow-x: hidden">
        <template
            v-if="componentNape === 'textAreaModel'">
          <div class="font-weight">文本内容</div>
          <textAreaEdit
              ref="textAreaEditRef"
              :value="textAreaValue"
              :disabled="false"
              :option="option"
              @changeText="handleChangeText"
          ></textAreaEdit>
        </template>
        <DropIndex @indexFx="addMetricClick" :currentLink="currentLink" @deleteLink="deleteLink" @indexEdit="edit"
                   @indexDragover="dragover"
                   @indexDrop="drop"
                   :link-data="linkData"
                   :dcOption="option.option"
                   :dcProp="option.prop"
                   :dragType="dragType"
                   :dragData="dragData"
                   v-for="(item, index) in indexList"
                   :key="index" :option="item"></DropIndex>
        <!--        // TODO-->
        <el-button
            type="primary"
            plain
            v-if="option.prop.dataSourceType !== DATA_SOURCE_TYPE.BIZ"
            :icon="Plus"
            class="mt-4"
            style="width: calc(100% - 10px)"
            @click="addRule"
        >
          {{ !isFilter ? "添加过滤条件" : "已设置条件过滤" }}
        </el-button>
        <div v-if="['newMap3D', 'map'].includes(componentNape)">
          <el-button
              type="primary"
              plain
              v-if="option.prop.dataSourceType !== DATA_SOURCE_TYPE.BIZ"
              :icon="Plus"
              class="mt-4"
              style="width: calc(100% - 10px)"
              @click="addSignRule"
          >
            {{ !isSignFilter ? "添加自定义标识" : "已设置标识" }}
          </el-button>
        </div>
        <div v-if="['sheet', 'map'].includes(componentNape)">
          <div class="font-weight">条件样式</div>
          <el-button
              type="primary"
              plain
              :icon="Plus"
              class="mt-4"
              style="width: calc(100% - 10px)"
              @click="addConditionsStyle"
          >
            {{ !isSetCondition ? "添加条件样式" : "已设置条件样式" }}
          </el-button>
        </div>
        <div v-if="['sheet'].includes(componentNape)">
          <div class="font-weight">表格内图表</div>
          <el-button
              type="primary"
              plain
              :icon="Plus"
              class="mt-4"
              style="width: calc(100% - 10px)"
              @click="addSheetChart"
          >
            {{ !isSetSheetChart ? "添加格内图表" : "已设置格内图表" }}
          </el-button>
        </div>
        <el-collapse v-model="leftActiveNames">
          <el-collapse-item title="更多操作" name="1">
            <MoreActions :option="option" :app="app" :currentLink="currentLink" :linkData="linkData"
                         @openCode="openCode"></MoreActions>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div
          class="flex1 cs-right hp100 overflow pl-10 pr-10 pb-10"
          style="max-width: 50%;overflow-x: hidden"
      >
        <template v-if="!isOnlyDataSet">
          <el-radio-group
              @change="modelChange"
              class="radio-button-sm mb-10"
              :model-value="option.prop.dataSourceType"
          >
            <el-radio-button :label="DATA_SOURCE_TYPE.DATA_CENTER"
            >数据分析
            </el-radio-button>
            <el-radio-button v-if="!bigScreenConfig.hideBizAnalysis" :label="DATA_SOURCE_TYPE.BIZ"
            >业务分析
            </el-radio-button>
          </el-radio-group>
          <SelectDimention
              hidePageSelect
              v-show="option.prop.dataSourceType === DATA_SOURCE_TYPE.BIZ"
              v-model="option.prop"
              :option="option"
              @select="handleSelectAction"
          ></SelectDimention>
        </template>
        <DatacenterSelect
            ref="datacenterSelectRef"
            v-model="option.prop"
            :isOnlyDataSet="isOnlyDataSet"
            :option="option"
            @select="handleSelectAction"
            v-if="option.prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER"
        ></DatacenterSelect>
        <el-collapse
            class="dim-set mini-collapse head-0 mt-10"
            v-model="activeNames"
        >
          <el-collapse-item
              v-if="!dicOption.dimensions.includes(componentNape) || !dicOption.groups.includes(componentNape)"
              title="维度"
              :name="1"
          >
            <DragIndex :option="dimensionDrag"></DragIndex>
          </el-collapse-item>
          <el-collapse-item title="指标" :name="2">
            <DragIndex :option="metricsDrag"></DragIndex>
          </el-collapse-item>
          <el-collapse-item v-if="option.prop.dataSourceType !== DATA_SOURCE_TYPE.DATA_CENTER" title="过滤条件"
                            :name="3">
            <DragIndex :option="filterDrag"></DragIndex>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <NumberSet
        :linkData="linkData"
        @confirm="setItemName"
        showDrill
        :setConfig="setConfig"
        v-if="showSet"
        v-model:show="showSet"
        v-model="numericSet"
        :option="option"
        :item="editItem"
    ></NumberSet>
    <el-dialog
        v-model="showRule"
        title="添加过滤条件"
        align-center
        width="auto"
    >
      <ruleFilter
          :linkData="linkData"
          ref="rule"
          :data="conditions"
          :isPageVar="true"
          :level="1"
          :formDef="defaultForm"
          :selectArr="option.prop.rConditions"
      ></ruleFilter>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelRule">清空</el-button>
          <el-button @click="showRule = false">取消</el-button>
          <el-button type="primary" @click="submitRule">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
        v-model="showSetCondition"
        title="条件样式"
        align-center
        width="1000px"
        destroy-on-close
    >
      <conditionStyle
          ref="conditionStyleRef"
          :linkData="linkData"
          :option="option.prop"
          :componentNape="componentNape"
          :styleConditionList="styleConditionList"
      ></conditionStyle>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelStyle">清空</el-button>
          <el-button @click="showSetCondition = false">取消</el-button>
          <el-button type="primary" @click="submitStyle">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
        v-model="showSignRule"
        title="自定义标识"
        align-center
        width="auto"
    >
      <div>标识：
        <el-button size="small" @click="addSignData">添加</el-button>
      </div>
      <div v-for="(signDataItem, index) in signDataList">
        <ruleFilter
            :linkData="linkData"
            ref="rule"
            :data="signDataItem"
            :isPageVar="true"
            :level="1"
            :formDef="defaultForm"
            :selectArr="option.prop.rConditions"
        ></ruleFilter>
        <div style="display: flex;">
          <img
              v-if="signDataItem.img"
              :src="signDataItem.img"
              alt=""
              style="width:40px;height: 40px;"
          />
          <el-input v-model="signDataItem.img" style="max-width: 300px;margin-left: 5px;">
            <template #append>
              <div @click="addSignRuleImg(index)">
                <i class="iconfont icon-img"></i>
              </div>
            </template>
          </el-input>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelSign">清空</el-button>
          <el-button @click="showSignRule = false">取消</el-button>
          <el-button type="primary" @click="submitSign">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
        v-model="showSetSheetChart"
        title="格内图表"
        align-center
        width="1000px"
        destroy-on-close
    >
      <sheetChartSet
          ref="sheetChartSetRef"
          :option="option.prop"
      ></sheetChartSet>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="clearSheetChartSet">清空</el-button>
          <el-button @click="showSetSheetChart = false">取消</el-button>
          <el-button type="primary" @click="submitSheetChart">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <CusMetrics
        v-model="showCusMetrics"
        @confirm="addMetric"
        :option="option.prop"
    ></CusMetrics>
    <codeedit
        @submit="closeCode"
        v-if="code.box"
        :title="code.title"
        :type="code.type"
        v-model="code.obj"
        v-model:visible="code.box"
    ></codeedit>
  </div>
</template>

<script setup>
import {
  computed,
  inject,
  nextTick, reactive,
  ref,
  toRef,
  unref,
  watch,
  watchEffect,
} from "vue";
import {useCommonMix} from "@/option/common/commonmix";
import NumberSet from "./NumericSet.vue";
import SelectDimention from "./StatisticSelect.vue";
import {
  DATA_SOURCE_TYPE, INDEX_TYPE, LOOP_KEY_MAP,
  METRIC_TYPE, SPREAD_SHEET_TYPE,
} from "@/option/common/dict.js";
import DatacenterSelect from "./DataCenterSelect.vue";
import {MODEL_COLUMN_TYPE} from "@/option/common/dict.js";
import ruleFilter from "./Rule.vue";
import {Edit, Plus, QuestionFilled} from "@element-plus/icons-vue";
import util from "@/option/common/util";
import CusMetrics from "@/option/components/dataCenter/cusMetrics.vue";
import {dicOption} from "@/option/config.js";
import {vSwapListByDrag} from "@/option/common/directives";
import codeedit from "@/page/group/code.vue";
import conditionStyle from "./conditionStyle.vue";
import sheetChartSet from './sheetChartSet.vue';
import DropIndex from './dropIndex.vue';
import DragIndex from './dragIndex.vue';
import {INDEX_DROP_TYPE} from "@/option/common/dict.js";
import {generateConfig} from "@/option/common/indexConfig.js"
import textAreaEdit from "./textAreaEdit.vue";
import MoreActions from "@/option/components/dataCenter/moreActions.vue";
import {website} from '@/config.js'
import {useRoute} from "vue-router";

let setConfig = ref("");
const props = defineProps({
  option: {},
  // 配置的类型 1 指标 维度 2 只有指标 3 指标 维度 分组 4 维度 指标 经度 纬度
  type: {
    type: String,
    default: "1",
  },
  linkData: {
    default() {
      return {};
    },
  },
});
const route = useRoute();
// 增加该字段控制入口变量
const isOnlyDataSet = !!(route.query?.zkDataType ?? false)
let componentNape = computed(() => {
  return props.option?.component?.prop;
});
if (componentNape.value === 'textArea' && !props.option?.prop?.limit) {
  props.option.prop.limit = 1
}
// 引入的页面这么注入
// provide('bigScreenConfig',{
//   hideBizAnalysis:true,
//   hideAdvSet:true,
// })
let bigScreenConfig = inject('bigScreenConfig', {})
// bigScreenConfig.hideBizAnalysis && 说明隐藏业务分析 默认设置成数据分析
if (!props.option.prop.dataSourceType) {
  props.option.prop.dataSourceType = DATA_SOURCE_TYPE.DATA_CENTER;
}
let main = unref(inject('main'))
let showCusMetrics = ref(false);
//  是新增辅助指标还是 总值指标
let cusMetricType = ref("");

let activeNames = ref([1, 2, 3]);
const {confirm, success, warning, error} = useCommonMix();
let dragType = ref(0);
let dragData = ref("");
let showSet = ref(false);
let numericSet = {};
let editItem = ref();
let showRule = ref(false);
const rule = ref(null);
const defaultForm = {};
let filterDatas = ref({});
let isFilter = ref(false);
let showSignRule = ref(false);
let isSignFilter = ref(false);
let isSetCondition = ref(false);
let isSetSheetChart = ref(false);
let showSetCondition = ref(false);
let showSetSheetChart = ref(false);
let signFilterData = ref([]);
let styleConditionData = ref([]);
let signImgIndex = ref('');
const conditionStyleRef = ref();
const sheetChartSetRef = ref();
legacyHandle()
let signDataList = ref([
  {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  }
])
const conditions = ref({
  operationSymbol: "and",
  rows: [
    {
      ruletype: "d",
      id: "1",
    },
  ],
});
let indexList = computed(() => {
  let _config
  for (let i = 0; i < website.baseList.length; i++) {
    let el = website.baseList[i]
    _config = el.children.find((el) => {
      return el.option.component.prop === componentNape.value
    })
    if (_config) break
  }

  return generateConfig(_config?.option?.dynamicConfig || {})
})
let dimensionDrag = computed(() => {
  return {
    dragStart(e, data) {
      dragStart(e, data, INDEX_TYPE.DIMENSION);
    },
    dragEnd(e) {
      dragEnd()
    },
    draggable(node, data) {
      return !data?.children?.length
    },
    show: props.option.prop.rDimensions,
    loopVariable: props.option.prop.rDimensions,
  }
})
let metricsDrag = computed(() => {
  return {
    dragStart(e, data) {
      dragStart(e, data, INDEX_TYPE.METRIC);
    },
    dragEnd(e) {
      dragEnd()
    },
    draggable(node, data) {
      return !data?.children?.length
    },
    show: props.option.prop.rMetrics,
    loopVariable: props.option.prop.rMetrics,
  }
})
let filterDrag = computed(() => {
  return {
    dragStart(e, data) {
      dragStart(e, data, INDEX_TYPE.FILTER);
    },
    dragEnd(e) {
      dragEnd()
    },
    draggable(node, data) {
      return !data?.children?.length
    },
    show: props.option.prop.rConditions,
    loopVariable: props.option.prop.rConditions,
  }
})
const textAreaEditRef = ref()
const styleConditionList = ref([{
  id: 1,
  type: '',
  ruleName: '',
  scope: '',
  conditions: {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  },
  fontColor: '',
  fontSize: '',
  bgColor: '',
}])
const textAreaValue = computed(() => {
  return props.option.prop.textAreaValue || ''
})
if (props.option.prop?.filterDatas) {
  conditions.value = util.changeToComponentData(
      props.option.prop.filterDatas,
      "conditions"
  );
  isFilter.value = true;
}

if (props.option.prop?.signFilterData) {
  signDataList.value = props.option.prop.signFilterData
  isSignFilter.value = true;
}

if (props.option.prop?.styleConditionData) {
  styleConditionList.value = props.option.prop.styleConditionData
  isSetCondition.value = true;
}

let code = reactive({
  title: "出参处理",
  box: false,
  type: "resHandler",
  obj: "",
})

function openCode(v) {
  if (v === 'option') {
    code.obj = props.option.prop.echartsOptionHandler
    code.type = v
    code.title = '配置处理'
    code.box = true;
  } else {
    code.obj = props.option.prop.responseHandler
    code.type = 'resHandler'
    code.title = '出参处理'
    code.box = true;
  }

}

function closeCode(value) {
  if (code.type === 'option') {
    props.option.prop.echartsOptionHandler = value;
  } else {
    props.option.prop.responseHandler = value;
  }
}

function addMetric(e) {
  let key = util.getIndex();
  let obj = {
    type: METRIC_TYPE.CUS,
    name: `公式字段_field_${key}`,
    code: key,
    formula: e,
  };
  if (unref(cusMetricType).includes(INDEX_DROP_TYPE.METRICS)) {
    props.option.prop.metrics.push(obj);
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.TOTAL) {
    props.option.prop.totalMetrics.push(obj);
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.REFERENCE) {
    if (!props.option.prop.reference) props.option.prop.reference = [];
    props.option.prop.reference.push(obj);
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.ASSIST) {
    props.option.prop.assistMetrics.push({
      ...obj,
      code: `${obj.code}$_assist`
    })
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.COLUMNS) {
    props.option.prop.columns.push(obj);
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.METRIC_L) {
    props.option.prop.metricsL.push(obj);
  } else if (unref(cusMetricType) === INDEX_DROP_TYPE.METRIC_R) {
    props.option.prop.metricsR.push(obj);
  }
}


function setItemName(v) {
  if (!editItem.value.fieldName) {
    editItem.value.fieldName = editItem.value.name || ''
  }
  if (v.indexAlias) {
    editItem.value.aliasName = editItem.value.fieldName.indexOf('公式字段_field') >= 0 ? `${v.indexAlias}(${editItem.value.fieldName})` : `${editItem.value.fieldName}(${v.indexAlias})`
    editItem.value.name = v.indexAlias
  }
}

// type 用来区分是指标还是总值指标
function addMetricClick(option) {
  cusMetricType.value = option.code;
  showCusMetrics.value = true;
}

let getApp = inject("getApp", null);
let app = getApp ? getApp() : inject("app");
// 在爱搭还是大屏
let editorType = inject("editorType");
watch(
    () => main.activeOption.signRuleImg,
    (val, oldVal) => {
      const signItem = signDataList.value[signImgIndex.value]
      // const signItem = signDataList[signImgIndex]
      signDataList.value.splice(signImgIndex.value, 1, {
        ...signItem,
        img: val,
      })
    }
)

function getIcon(type) {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    case METRIC_TYPE.CUS:
      return "fx";
    default:
      return "abc";
  }
}

function addRule() {
  if (
      (props.option.prop.rConditions && props.option.prop.rConditions.length) ||
      isFilter.value
  ) {
    if (props.option.prop.filterDatas) {
      conditions.value = util.changeToComponentData(props.option.prop.filterDatas, "conditions");
    }
    showRule.value = true;
  } else {
    util.confirm("请先选择筛选条件数据", "提示", {
      confirmButtonText: "确定",
      type: "warning",
      showCancelButton: false,
    });
  }
}

function addConditionsStyle() {
  if (
      (props.option.prop.rConditions && props.option.prop.rConditions.length) ||
      isSetCondition.value
  ) {
    showSetCondition.value = true;
  } else {
    util.confirm("请先选择筛选条件数据", "提示", {
      confirmButtonText: "确定",
      type: "warning",
      showCancelButton: false,
    });
  }
}

function addSignRule() {
  if (
      (props.option.prop.rConditions && props.option.prop.rConditions.length) ||
      isSignFilter.value
  ) {
    showSignRule.value = true;
  } else {
    util.confirm("请先选择筛选条件数据", "提示", {
      confirmButtonText: "确定",
      type: "warning",
      showCancelButton: false,
    });
  }
}

function addSignData() {
  signDataList.value = [...signDataList.value, {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  }]
}

function addSignRuleImg(index) {
  signImgIndex.value = index
  main.handleOpenImg('activeOption.signRuleImg')
}


function addSheetChart() {
  showSetSheetChart.value = true;
}

function resetDimSet() {
  props.option.prop.dimensions = [];
  props.option.prop.metrics = [];
  props.option.prop.conditions = [];
  props.option.prop.groups = [];
  props.option.prop.metricsR = [];
  props.option.prop.metricsL = [];
  props.option.prop.totalMetrics = [];
  props.option.prop.assistMetrics = [];
  props.option.prop.reference = [];
  props.option.prop.columns = [];
  props.option.prop.rows = [];
  props.option.prop.rDimensions = [];
  props.option.prop.rMetrics = [];
  props.option.prop.rConditions = [];
}

let ov = props.option.prop.dataSourceType
const datacenterSelectRef = ref()

function modelChange(v) {
  // 如果配置过再提示 不然初始化进来提示不友好
  if (props.option.prop.dataCenter) {
    util
        .confirm("切换将自动重置维度指标等配置，是否确定切换？")
        .then(() => {
          resetDimSet();
          props.option.prop.dataSourceType = v;
          ov = v
          setTimeout(() => {
            datacenterSelectRef.value?.initSet()
          }, 1000)
        })
        .catch(() => {
          props.option.prop.dataSourceType = "";
          nextTick(() => {
            props.option.prop.dataSourceType = ov;
          });
        });
  } else {
    props.option.prop.dataSourceType = v;
  }
}

function cancelRule() {
  conditions.value = {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  };
  filterDatas.value = {};
  isFilter.value = false;
}

function cancelStyle() {
  styleConditionList.value = [{
    id: 1,
    type: '',
    ruleName: '',
    scope: '',
    conditions: {
      operationSymbol: "and",
      rows: [
        {
          ruletype: "d",
          id: "1",
        },
      ],
    },
    fontColor: '',
    fontSize: '',
    bgColor: '',
  }]
  conditionStyleRef.value.styleConditionData = styleConditionList.value
}

function clearSheetChartSet() {
  sheetChartSetRef.value.clearData()
}

function submitRule() {
  // 保存过滤条件
  if (filterDatas.value) {
    filterDatas.value = rule.value.changeToFormData(
        conditions.value,
        "conditions"
    );
    // 处理过滤条件的数据
    props.option.prop.filterDatas = filterDatas;
    isFilter.value = true;
  }
  showRule.value = false;
}

function cancelSign() {
  signDataList.value = [{
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  }];
  signFilterData.value = [];
  isSignFilter.value = false;
}

function submitSign() {
  // 保存过滤条件
  if (signFilterData.value) {
    signFilterData.value = [...signDataList.value]
    // 处理过滤条件的数据
    props.option.prop.signFilterData = [...signDataList.value];
    isSignFilter.value = true;
  }
  showSignRule.value = false;
}

function submitStyle() {
  if (styleConditionData.value) {
    styleConditionData.value = conditionStyleRef.value.styleConditionData
    props.option.prop.styleConditionData = conditionStyleRef.value.styleConditionData;
    styleConditionList.value = conditionStyleRef.value.styleConditionData;
    isSetCondition.value = true;
  }
  showSetCondition.value = false
}

function submitSheetChart() {
  const sheetChartData = sheetChartSetRef.value.submitData()
  if (sheetChartData && sheetChartData.length) {
    props.option.prop.sheetChartData = sheetChartData
    showSetSheetChart.value = false
  }
}

function dragStart(e, item, type) {
  // 拖拽类型 做高亮处理
  dragType.value = type;
  dragData.value = {
    ...dropDataFilter(item),
    type: METRIC_TYPE.DEFAULT,
    set: {
      "nullList": dragType.value === INDEX_TYPE.DIMENSION ? ["null", "emptyString", "undefined"] : ["null", "emptyString", "NaN", "Infinity", "undefined"],
      "nullValue": "--",
    }
  };
}

function dragover(e, type) {
  // 指标维度可放关联数据 列配置
  // 列可配置维度 大伟要求
  if ((type === INDEX_DROP_TYPE.COLUMNS ||
          type === INDEX_DROP_TYPE.ROW ||
          type === INDEX_DROP_TYPE.LINK)
      &&
      (dragType.value === INDEX_TYPE.DIMENSION || dragType.value === INDEX_TYPE.METRIC)
  ) {
    return e.preventDefault();
  }
  if (dragType.value === INDEX_TYPE.DIMENSION &&
      (type === INDEX_DROP_TYPE.DIMENSION ||
          type === INDEX_DROP_TYPE.GROUP)) {
    return e.preventDefault();
  }
  // 这个是拖辅助指标或者总值指标
  if (dragType.value === INDEX_TYPE.METRIC &&
      (type === INDEX_DROP_TYPE.ASSIST ||
          type === INDEX_DROP_TYPE.TOTAL ||
          type === INDEX_DROP_TYPE.LONGITUDE ||
          type === INDEX_DROP_TYPE.LATITUDE ||
          type === INDEX_DROP_TYPE.METRIC_L ||
          type === INDEX_DROP_TYPE.METRIC_R ||
          type === INDEX_DROP_TYPE.REFERENCE)) {
    return e.preventDefault();
  }
  // 这个是拖辅助指标或者总值指标
  if (dragType.value === INDEX_TYPE.FILTER &&
      (type === INDEX_DROP_TYPE.LABEL_IDENT)) {
    return e.preventDefault();
  }
  if (dragType.value === type) {
    e.preventDefault();
  }
}

function dragEnd() {
  dragType.value = 0;
  dragData.value = ''
}

let currentLink = computed({
  get() {
    return props.linkData[props.option?.index || props.option?.ref];
  },
  set(v) {
    props.linkData[props.option?.index || props.option?.ref] = v;
  },
});

function deleteLink(item) {
  let el = props.linkData[props.option?.index || props.option?.ref];
  delete el[item.code];
}

function handleMultiIndex(key, option) {
  if (!props.option.prop[key] || !option.multiple) props.option.prop[key] = [];
  let exist = props.option.prop[key].find((el) => el.code === dragData.value.code)
  // 主次指标 去重
  if (key === LOOP_KEY_MAP[INDEX_DROP_TYPE.TOTAL] || key === LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_L] || key === LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_R] || key === LOOP_KEY_MAP[INDEX_DROP_TYPE.METRICS]) {
    exist = props.option.prop[LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_L]]?.find((el) => el.code === dragData.value.code)
        || props.option.prop[LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_R]]?.find((el) => el.code === dragData.value.code)
        || props.option.prop[LOOP_KEY_MAP[INDEX_DROP_TYPE.METRICS]]?.find((el) => el.code === dragData.value.code)
        || props.option.prop[LOOP_KEY_MAP[INDEX_DROP_TYPE.TOTAL]]?.find((el) => el.code === dragData.value.code)
  }
  if (!exist) {
    props.option.prop[key].push(dragData.value);
  } else {
    // 2023.11.11 增加指标等可重复加后缀的方式
    props.option.prop[key].push({
      ...dragData.value,
      code: `${dragData.value.code}#${util.getUUID(3, 16)}`
    });
  }
}

function drop(option, type) {
  // 如果是排序这里就没有数据，直接返回
  if (!dragData.value) return;
  // 维度
  if (type === INDEX_DROP_TYPE.DIMENSION) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.DIMENSION], option)
  }
  // 指标
  if (type === INDEX_DROP_TYPE.METRICS) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.METRICS], option)
  }
  // 过滤条件
  if (type === INDEX_DROP_TYPE.FILTER) {
    if (props.option.prop.dataSourceType === DATA_SOURCE_TYPE.BIZ) {
      handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.FILTER], option)
    } else {
      props.option.prop.filterDatas = filterDatas;
    }
  }
  // 分组
  if (type === INDEX_DROP_TYPE.GROUP) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.GROUP], option)
  }
  // 关联数据 仅仅在大屏环境中配置 爱搭下无效爱搭用变量
  if (type === INDEX_DROP_TYPE.LINK) {
    // console.log(currentLink.value)
    // console.log(dragData.value)
    if (!currentLink.value) currentLink.value = {name: props.option?.name};
    if (!currentLink.value[dragData.value.code]) {
      currentLink.value[dragData.value.code] = {
        ...dragData.value,
        type: dragType.value,
      };
    }
    // 修改组件名称，处理多个相同组件二次改名区分变量问题
    if (currentLink.value && currentLink.value?.name && currentLink.value?.name !== props.option?.name) {
      currentLink.value.name = props.option?.name
    }
  }
  // 辅助指标
  if (type === INDEX_DROP_TYPE.ASSIST) {
    if (!props.option.prop.assistMetrics || !option.multiple) props.option.prop.assistMetrics = [];
    if (
        !props.option.prop.assistMetrics.find(
            (el) => el.code === dragData.value.code + '$_assist'
        )
    ) {
      props.option.prop.assistMetrics.push({
        ...dragData.value,
        code: `${dragData.value.code}$_assist`
      });
    } else {
      props.option.prop.assistMetrics.push({
        ...dragData.value,
        code: `${dragData.value.code}#${util.getUUID(3, 16)}$_assist`
      });
    }
  }
  // 总值指标
  if (type === INDEX_DROP_TYPE.TOTAL) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.TOTAL], option)
  }
  // 列
  if (type === INDEX_DROP_TYPE.COLUMNS) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.COLUMNS], option)
  }
  // 行
  if (type === INDEX_DROP_TYPE.ROW) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.ROW], option)
  }
  if (type === INDEX_DROP_TYPE.REFERENCE) {
    // TODO 待验证
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.REFERENCE], option)
  }
  // 自动处理列数据
  if (props.option?.component?.prop === "table") {
    let columns = props.option.option.column;
    // 是否是第一次 第一次清空columns
    if (!props.option.prop._droped) {
      props.option.option.column = [];
    }
    props.option.prop._droped = true;
    let res = [];
    // 处理组的数据
    props.option.prop.groups?.forEach((el) => {
      let item = columns.find((_el) => _el.prop === el.code);
      if (!item) {
        res.push({
          label: el.name,
          prop: el.code,
        });
      } else {
        res.push(item);
      }
    });

    props.option.prop.columns?.forEach((el) => {
      let item = columns.find((_el) => _el.prop === el.code);
      if (!item) {
        res.push({
          label: el.name,
          prop: el.code,
        });
      } else {
        res.push(item);
      }
    });

    props.option.option.column = res;
  }
  // 经度
  if (type === INDEX_DROP_TYPE.LONGITUDE) {
    props.option.prop.longitude = [dragData.value]
  }
  // 纬度
  if (type === INDEX_DROP_TYPE.LATITUDE) {
    props.option.prop.latitude = [dragData.value]
  }

  // 次指标
  if (type === INDEX_DROP_TYPE.METRIC_L) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_L], option)
  }
  // 次指标1
  if (type === INDEX_DROP_TYPE.METRIC_R) {
    handleMultiIndex(LOOP_KEY_MAP[INDEX_DROP_TYPE.METRIC_R], option)
  }
}

/**
 * 处理指标维度数据保存prop
 */
function dropDataFilter(data = {}) {
  return {
    fieldName: data.fieldName,
    code: data.code,
    modelId: data.modelId,
    modelCode: data.modelCode,
    type: data.type,
    id: data.id,
    fieldId: data.fieldId,
    fieldKey: data.fieldKey,
    fieldCode: data.fieldCode,
    name: data.name,
    fieldType: data.fieldType,
  }
}

function deleteMetrics(index, type) {
  if (type == 'line') {
    props.option.prop.lineMetrics.splice(index, 1)
  } else if (type == 'bar') {
    props.option.prop.barMetrics.splice(index, 1)
  }
  // 老版本 混合图逻辑
  // props.option.prop.metrics = props.option.prop.lineMetrics.concat(props.option.prop.barMetrics || [])
}

function edit(data, index, option) {
  if (!data.set) {
    data.set = {};
  }
  numericSet = toRef(data, "set");
  // 编辑的类型 过滤条件需要特殊处理
  setConfig.value = option;
  editItem.value = data;
  showSet.value = true;
}

function clearSelectedInfo() {
  props.option.prop.dimensions = [];
  props.option.prop.metrics = [];
  props.option.prop.conditions = [];
  props.option.prop.groups = [];
  currentLink.value = {name: props.option?.name};
  props.option.prop.assistMetrics = [];
  props.option.prop.totalMetrics = [];
  props.option.prop.metricsL = [];
  props.option.prop.metricsR = [];
  props.option.prop.lineMetrics = [];
  props.option.prop.barMetrics = [];
  props.option.prop.longitude = [];
  props.option.prop.latitude = [];
  props.option.prop.columns = [];
  // 表格的列配置清空
  props.option.option.column = [];
  // 清空配置的规则
  cancelRule();
}

function handleSelectAction(v, metricsParams, dimensionsParams, queryParams, isClearSelected = true) {
  // isClearSelected：刷新按钮触发时 只刷新列表数据，左侧已选项保留配置
  isClearSelected && clearSelectedInfo();
  props.option.prop.rDimensions = dimensionsParams;
  props.option.prop.rMetrics = metricsParams;
  if (queryParams?.length) {
    props.option.prop.rConditions =
        queryParams?.map((el) => ({
          name: el.fieldName,
          code: el.fieldCode,
          fieldType: el.fieldType,
          fieldId: el.fieldId,
          type: "basic",
        })) || [];
  } else {
    props.option.prop.rConditions =
        dimensionsParams?.map((el) => ({
          name: el.name,
          code: el.code,
          fieldType: el.fieldType,
          id: el.id,
          fieldId: el.fieldId,
          type: "dim",
        })) || [];
  }
}

/**
 * 兼容老版本
 */
function legacyHandle() {
  // 说明是老版本的双轴
  if (props.option.prop?.lineMetrics?.length && !props.option.prop?.metricsR?.length) {
    props.option.prop.metricsR = [...props.option.prop.lineMetrics]
  }
  if (props.option.prop?.barMetrics?.length && !props.option.prop?.metricsL?.length) {
    props.option.prop.metricsL = [...props.option.prop.barMetrics]
  }
  // 老版本的折线双轴兼容
  const {
    metrics = []
  } = props.option.prop
  if (metrics.find(metItem => metItem.metricType === 'sub')) {
    props.option.prop.metrics = metrics.filter(item => item.metricType !== 'sub')
    props.option.prop.metricsL = metrics.filter(item => item.metricType === 'sub')
  }
}

function handleChangeText(innerHTML) {
  props.option.prop.textAreaValue = innerHTML
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

:deep(.el-tree-node__expand-icon.is-leaf) {
  display: none;
}

.cs-left {
  padding-right: 10px;
}

.cs-right {
  padding-left: 10px;
  border-left: 1px solid $borderColor;
}

:deep(.el-tree__empty-text) {
  font-size: 12px;
}

:deep(.el-tree-node__content) {
  height: unset;
  min-height: 26px;
}

:deep(.seltree_content) {
  white-space: normal;
  word-break: break-all;
}

:deep(.radio-button-sm .el-radio-button__inner) {
  padding: 5px 3px;
}

.ellipse-name-left {
  max-width: 95px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  .rei {
    font-size: 12px;
  }
}

.ellipse-name-right {
  font-size: 12px;
  max-width: 146px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: rgb(96, 98, 102);

  svg {
    font-size: 12px;
  }
}

:deep(.head-0 .el-collapse-item__header) {
  padding-left: 0;
}

:deep(.icon-bind) {
  font-size: 15px;
}
</style>
<style lang="scss">
@import "@/styles/variables";

#datacenter-cus {
  * {
    box-sizing: border-box;
  }

  .flex:not(.vcenter) {
    align-items: flex-start;
  }

  label {
    font-weight: 700;
  }
}

.dark {
  .el-icon {
    //color: $darkTextColor;
  }

  .el-collapse-item__content {
    color: $darkTextColor;
  }
}
</style>